import React from 'react'
import TopSection from './components/TopSection'
// import Navbar from './components/Navbar'
import BottomSection from './components/BottomSection'
import './css/App.css'

const App = () => {
    return (
        <div className="app-component">
            <TopSection />
            {/* <Navbar /> */}
            <BottomSection />
        </div>
    )
}

export default App
